import { ReactElement, useCallback } from 'react';
import { createFetchContext } from '../../../../../components/contexts/FetchContextFactory';
import DisplayError from '../../../../../components/info/DisplayError';
import Loading from '../../../../../components/info/Loading';
import { StudentStudyPlansResponse } from '../types';
import { getStudentStudyPlans } from '../../../api/studentStudyPlansRequests';

export interface StudyPlansLoaderProps<T> {
  studentId: number;
  children: (props: { data: T; refresh: Function }) => ReactElement;
}

const { FetchProvider, FetchConsumer } = createFetchContext<
  {
    studentId: number;
  },
  StudentStudyPlansResponse
>();

export function StudyPlansLoader({
  studentId,
  children,
}: StudyPlansLoaderProps<StudentStudyPlansResponse>) {
  const request = useCallback(() => {
    return getStudentStudyPlans(studentId);
  }, [studentId]);
  return (
    <FetchProvider
      request={request}
      defaultQuery={{ studentId }}
      fetchImmediately
    >
      <FetchConsumer>
        {({ data, loading, error, refresh }) => {
          if (error) {
            return (
              <DisplayError
                insideCard
                textBody={error.code}
                retryAction={refresh}
                loadingAction={loading}
              />
            );
          }

          if (loading) {
            return (
              <div className="mx-3">
                <Loading insideCard />
              </div>
            );
          }

          if (!data) {
            return (
              <DisplayError
                insideCard
                textBody="Data no cargada"
                retryAction={refresh}
                loadingAction={loading}
              />
            );
          }

          return children({ data, refresh });
        }}
      </FetchConsumer>
    </FetchProvider>
  );
}
